import { useCorvusEventList } from '@emerald-works/react-event-bus-client'
import { useEffect } from "react"
import { fetchRecordingList, paginateRecordingList } from "src/slices/recording/recordingSlice"
import { RecordingList } from "src/components/RecordingList/RecordingList"
import { Box, Button } from '@mui/material'
import { useRecordingHook } from "src/slices/recording/useRecordingHook"

const Dashboard = () => {
  const { lastKey } = useRecordingHook()

  const [fetchRecordingListEvent, paginateRecordingListEvent] = useCorvusEventList([fetchRecordingList, paginateRecordingList])
  useEffect(() => {
    fetchRecordingListEvent.trigger({
      lastKey: null,
    })
  }, [fetchRecordingListEvent])

  return (
    <>
      <Box display='flex' flexWrap='wrap' gap={4} marginTop={4}>
        <RecordingList loading={fetchRecordingListEvent.isWorking} />
      </Box>
      <Button onClick={() => paginateRecordingListEvent.trigger({
        lastKey
      })} disabled={paginateRecordingListEvent.isWorking}>More</Button>
    </> 
  )

}

export { Dashboard }
